module.exports = __webpack_public_path__ + "img/1699338535577-WhatsApp Image 2023-11-07 at 14.28.15.jpeg.ef633614.webp";